"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Transform RGB to HEX
 */
function rgbToHex(r, g, b) {
    function transform(number) {
        var hex = number.toString(16);
        return hex.length === 1 ? "0" + hex : hex;
    }
    return "#" + [r, g, b].map(transform).join('');
}
exports.default = rgbToHex;
//# sourceMappingURL=rgbToHex.js.map